import { FC } from "react";
import { Redirect } from "react-router-dom";
import withCompositeResource, { WrappedComponentProps } from "@/components/recource/CompositeResource";
import { useHasFeature } from "@/utils/useHasFeature";


const ContinuityCompositeContent: FC<WrappedComponentProps> = ({
  children,
}) => {
  const hasFeature = useHasFeature()

  if (!hasFeature.OnDataSecureDB) {
    return (
      hasFeature.requested ? <Redirect to="/" /> : null
    )
  }
  return (
    <>{children}</>
  )
}

export const ContinuityComposite = withCompositeResource(ContinuityCompositeContent);